import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { kebabCase } from 'lodash';
class DocumentsRow extends Component {
  constructor(props) {
    super(props);
    this.handleClick = props.onClick.bind(this, props.data.id);
    this.handleChange = props.onChange.bind(this, props.data.id);
  }
  render() {
    let checkbox;
    const {
      data,
      hasActions,
      index,
      isSelected
    } = this.props;
    if (hasActions) {
      checkbox = /*#__PURE__*/React.createElement("td", {
        "aria-label": "select-document-checkbox",
        style: {
          width: '1px',
          verticalAlign: 'middle'
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: isSelected,
        onChange: this.handleChange
      }));
    }
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        height: '30px'
      },
      className: `t-dr-${index}`
    }, checkbox, /*#__PURE__*/React.createElement("td", {
      className: `t-dr-display-name-${kebabCase(data.displayName)}`
    }, /*#__PURE__*/React.createElement("div", {
      role: "link",
      tabIndex: "0",
      onClick: this.handleClick,
      onKeyPress: this.handleClick
    }, data.displayName)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      role: "link",
      tabIndex: "0",
      onClick: this.handleClick,
      onKeyPress: this.handleClick
    }, moment(data.appCreated).format('MM/DD/YYYY'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      role: "link",
      tabIndex: "0",
      onClick: this.handleClick,
      onKeyPress: this.handleClick
    }, `${data.firstName} ${data.lastName}`)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      role: "link",
      tabIndex: "0",
      onClick: this.handleClick,
      onKeyPress: this.handleClick
    }, (data.byteSize / 1024).toFixed(1), " kB")));
  }
}
DocumentsRow.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    appCreated: PropTypes.string,
    displayName: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.string,
    lastName: PropTypes.string,
    byteSize: PropTypes.number
  }).isRequired,
  hasActions: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired
};
export default DocumentsRow;